import { GetterTree }                             from 'vuex';
import { RootState }                              from '@/store/store.types';
import { BuilderGroupContent, XAxisReportLayout } from '@/views/x-axis-report/report-edit/types/types';
import { XAxisReportPanelGroups }                 from '@/views/x-axis-report/report-edit/helpers/x-axis-report.variables';
import { LeadFilterDetails }                      from '@/components/filter-panel/filter-panel.types';

const getters: GetterTree<XAxisReportLayout, RootState> = {
  getLeadElement(state): LeadFilterDetails {
    let name = '';
    let groupName = '';

    Object.values(XAxisReportPanelGroups)
      .forEach((key: XAxisReportPanelGroups) => {
        state.groups[ key ].data
          .forEach((content: BuilderGroupContent) => {
            if (content.leadElement) {
              name = content.columnName;
              groupName = key.toString();
            }
          });
      });

    return {
      name,
      groupName,
      tabName: 'custom',
    };
  },
};

export default getters;
